module.exports = __webpack_public_path__ + "img/img_3.faa8f14d.png";